import React from "react";
import "./Produk1.scss";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import Viola5images from "./Viola5.js";
import Viola6images from "./Viola6.js";
import Viola7images from "./Viola7.js";
import Viola8images from "./Viola8.js";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
  faArrowsUpDownLeftRight,
  faMedal,
} from "@fortawesome/free-solid-svg-icons";
import {faHouse} from "@fortawesome/free-solid-svg-icons";
import {faBed} from "@fortawesome/free-solid-svg-icons";
import {faShower} from "@fortawesome/free-solid-svg-icons";
import {faWhatsapp} from "@fortawesome/free-brands-svg-icons";

const Produk1 = () => {
  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const Dayanawa = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6287713153298&text=Halo%20Billy,%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20rumah%20ini%20(Viola%205)%20https://marketing-crowngading.com/&type=phone_number&app_absent=0";
    window.open(whatsappLink, "_blank");
  };
  const Amandawa = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6287713153298&text=Halo%20Billy,%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20rumah%20ini%20(Viola%206)%20https://marketing-crowngading.com/&type=phone_number&app_absent=0";
    window.open(whatsappLink, "_blank");
  };
  const Cynthiawa = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6287713153298&text=Halo%20Billy,%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20rumah%20ini%20(Viola%207)%20https://marketing-crowngading.com/&type=phone_number&app_absent=0";
    window.open(whatsappLink, "_blank");
  };
  const Gavina9 = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6287713153298&text=Halo%20Billy,%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20rumah%20ini%20(Viola%208)%20https://marketing-crowngading.com/&type=phone_number&app_absent=0";
    window.open(whatsappLink, "_blank");
  };

  return (
    <div className="container-viola">
      <div className="containercard3">
        <div className="card">
          <Slider {...settings}>
            {Viola5images.map((image, index) => (
              <img className="imagecard" key={index} src={image} alt={image} />
            ))}
          </Slider>
          <div className="container-rumah">
            <div className="nama-rumah">Viola 5</div>
            <div className="gridmap">
              <FontAwesomeIcon className="icon" color="grey" icon={faMedal} />
              <div className="namalokasi">Free PPN</div>
            </div>
          </div>
          <div className="containercicilan">
            <div className="judulkartu">
              <div className="startfrom">Start From</div>
            </div>
            <div className="cicilansumban">
              <div className="angka">5</div>
              <div className="ket">Juta/Bulan</div>
            </div>
          </div>
          <div className="gridspek">
            <FontAwesomeIcon color="#2b2b2b" icon={faArrowsUpDownLeftRight} />
            <span> 55m²</span>
            <FontAwesomeIcon color="#2b2b2b" icon={faHouse} />
            <span> 69m²</span>
            <FontAwesomeIcon color="#2b2b2b" icon={faBed} />
            <span> 3</span>
            <FontAwesomeIcon color="#2b2b2b" icon={faShower} />
            <span> 2</span>
          </div>
          <div className="containerwhatsapp">
            <button onClick={Dayanawa} className="whatsappsumban">
              <FontAwesomeIcon icon={faWhatsapp} /> Whatsapp
            </button>
          </div>
        </div>
        <div className="card">
          <Slider {...settings}>
            {Viola6images.map((image, index) => (
              <img className="imagecard" key={index} src={image} alt={image} />
            ))}
          </Slider>
          <div className="container-rumah">
            <div className="nama-rumah">Viola 6</div>
            <div className="gridmap">
              <FontAwesomeIcon className="icon" color="grey" icon={faMedal} />
              <div className="namalokasi">Free PPN</div>
            </div>
          </div>
          <div className="containercicilan">
            <div className="judulkartu">
              <div className="startfrom">Start From</div>
            </div>
            <div className="cicilansumban">
              <div className="angka">7</div>
              <div className="ket">Juta/Bulan</div>
            </div>
          </div>
          <div className="gridspek">
            <FontAwesomeIcon color="#2b2b2b" icon={faArrowsUpDownLeftRight} />
            <span> 66m²</span>
            <FontAwesomeIcon color="#2b2b2b" icon={faHouse} />
            <span> 82m²</span>
            <FontAwesomeIcon color="#2b2b2b" icon={faBed} />
            <span> 3</span>
            <FontAwesomeIcon color="#2b2b2b" icon={faShower} />
            <span> 2</span>
          </div>
          <div className="containerwhatsapp">
            <button onClick={Amandawa} className="whatsappsumban">
              <FontAwesomeIcon icon={faWhatsapp} /> Whatsapp
            </button>
          </div>
        </div>
        <div className="card">
          <Slider {...settings}>
            {Viola7images.map((image, index) => (
              <img className="imagecard" key={index} src={image} alt={image} />
            ))}
          </Slider>
          <div className="container-rumah">
            <div className="nama-rumah">Viola 7</div>
            <div className="gridmap">
              <FontAwesomeIcon className="icon" color="grey" icon={faMedal} />
              <div className="namalokasi">Free PPN</div>
            </div>
          </div>
          <div className="containercicilan">
            <div className="judulkartu">
              <div className="startfrom">Start From</div>
            </div>
            <div className="cicilansumban">
              <div className="angka">9</div>
              <div className="ket">Juta/Bulan</div>
            </div>
          </div>
          <div className="gridspek">
            <FontAwesomeIcon color="#2b2b2b" icon={faArrowsUpDownLeftRight} />
            <span> 91m²</span>
            <FontAwesomeIcon color="#2b2b2b" icon={faHouse} />
            <span> 109m²</span>
            <FontAwesomeIcon color="#2b2b2b" icon={faBed} />
            <span> 4+1</span>
            <FontAwesomeIcon color="#2b2b2b" icon={faShower} />
            <span> 3+1</span>
          </div>
          <div className="containerwhatsapp">
            <button onClick={Cynthiawa} className="whatsappsumban">
              <FontAwesomeIcon icon={faWhatsapp} /> Whatsapp
            </button>
          </div>
        </div>
        <div className="card">
          <Slider {...settings}>
            {Viola8images.map((image, index) => (
              <img className="imagecard" key={index} src={image} alt={image} />
            ))}
          </Slider>
          <div className="container-rumah">
            <div className="nama-rumah">Viola 8</div>
            <div className="gridmap">
              <FontAwesomeIcon className="icon" color="grey" icon={faMedal} />
              <div className="namalokasi">Free PPN</div>
            </div>
          </div>
          <div className="containercicilan">
            <div className="judulkartu">
              <div className="startfrom">Start From</div>
            </div>
            <div className="cicilansumban">
              <div className="angka">10</div>
              <div className="ket">Juta/Bulan</div>
            </div>
          </div>
          <div className="gridspek">
            <FontAwesomeIcon color="#2b2b2b" icon={faArrowsUpDownLeftRight} />
            <span> 104m²</span>
            <FontAwesomeIcon color="#2b2b2b" icon={faHouse} />
            <span> 124m²</span>
            <FontAwesomeIcon color="#2b2b2b" icon={faBed} />
            <span> 4+1</span>
            <FontAwesomeIcon color="#2b2b2b" icon={faShower} />
            <span> 3+1</span>
          </div>
          <div className="containerwhatsapp">
            <button onClick={Gavina9} className="whatsappsumban">
              <FontAwesomeIcon icon={faWhatsapp} /> Whatsapp
            </button>
          </div>
        </div>
      </div>
      <div></div>
    </div>
  );
};

export default Produk1;
